export default {
    "slug": "dungeon",
    "title": "Diehorde",
    "firstChapterKey": "weakness",
    "chapters": {
        "weakness": require("./weakness").default,
        "rivals": require("./rivals").default,
        "strength": require("./strength").default,
        "distance": require("./distance").default,
        "speed": require("./speed").default,
        // "armor": require("./armor").default,
        // "magic": require("./magic").default,
        // "fiendpit": require("./fiendpit").default,
	},
    "configuration": {
        "darkness": true,
        "squigglevision": true,
    },
    "player": {
        "affiliation": "good",
        "inventory": {
            "gold": 0,
        },
        "party": {
            "units": {
                "swordlich": {
                    "key": "swordlich",
                    "jobKey": "sword",
                    "affiliation": "good",

                    "isRecruited": true,

                    "maxhealth": 25,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "rally",
                        "recruit",
                    ],

                    "name": "Necromancer",
                    "jobName": "Swordlich",
                    "faceKey": "knight",
                    "bodyKey": "good",
                },
                "daggerlich": {
                    "key": "daggerlich",
                    "jobKey": "dagger",
                    "affiliation": "good",

                    "isRecruited": true,

                    "maxhealth": 25,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "rally",
                        "recruit",
                    ],

                    "name": "Necromancer",
                    "jobName": "Assassin-lich",
                    "faceKey": "knight",
                    "bodyKey": "good",
                },
                "magelich": {
                    "key": "magelich",
                    "jobKey": "mage",
                    "affiliation": "good",

                    "isRecruited": true,

                    "maxhealth": 25,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "rally",
                        "recruit",
                    ],

                    "name": "Necromancer",
                    "jobName": "Wizard-lich",
                    "faceKey": "knight",
                    "bodyKey": "good",
                },
                "swordskull": {
                    "key": "swordskull",
                    "jobKey": "sword",
                    "affiliation": "good",

                    "isRecruited": true,

                    "maxhealth": 25,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "swap",
                        "recruit",
                    ],

                    "name": "Bones",
                    "jobName": "Swordskull",
                    "faceKey": "skull",
                    "bodyKey": "good",
                },
                "splitbone": {
                    "key": "splitbone",
                    "jobKey": "hammer",
                    "affiliation": "good",

                    "maxhealth": 25,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "smite",
                        "recruit",
                    ],

                    "name": "Split",
                    "jobName": "Splitbone",
                    "faceKey": "skull",
                    "bodyKey": "good",
                },
                "speardead": {
                    "key": "speardead",
                    "jobKey": "spear",
                    "affiliation": "good",

                    "isRecruited": true,

                    "maxhealth": 25,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "swap",
                        "recruit",
                    ],

                    "name": "Shinsplint",
                    "jobName": "Speardead",
                    "faceKey": "skull",
                    "bodyKey": "good",
                },
                "spearknight": {
                    "key": "spearknight",
                    "jobKey": "spearknight",
                    "affiliation": "good",

                    "maxhealth": 35,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "swap",
                        "recruit",
                    ],

                    "name": "Patella",
                    "jobName": "Shieldknight",
                    "faceKey": "skull",
                    "bodyKey": "good",

                    "facts": [
                        "Can only move 1 square a turn, but has high defense.",
                    ]
                },
                "axeknight": {
                    "key": "axeknight",
                    "jobKey": "hammercavalier",
                    "affiliation": "good",

                    "maxhealth": 25,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "smite",
                        "recruit",
                    ],

                    "name": "Fibia",
                    "faceKey": "skull",
                    "bodyKey": "good",

                    "facts": [
                        "Can move 3(!) squares a turn!",
                        // "Can push an ally 1 square.",
                    ]
                },
                "highpriest": {
                    "key": "highpriest",
                    "jobKey": "priest",
                    "affiliation": "good",

                    "maxhealth": 15,
                    "defense": 1,
                    "skills": [
                        "inflict-damage",
                        "restore-health",
                        "recruit",
                    ],

                    "name": "Vertebri",
                    "faceKey": "skull",
                    "bodyKey": "good",

                    "facts": [
                        "Can heal close-range OR attack far-range.",
                    ]
                },
                "daggercloak": {
                    "key": "daggercloak",
                    "jobKey": "dagger",
                    "affiliation": "good",

                    "maxhealth": 20,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "pull",
                        "recruit",
                    ],

                    "name": "Phlanges",
                    "faceKey": "skull",
                    "bodyKey": "good",

                    "facts": [
                        "Can attack from 2 squares away.",
                    ]
                },
                "gunner": {
                    "key": "gunner",
                    "jobKey": "gun",
                    "affiliation": "good",

                    "maxhealth": 20,
                    "power": 13,
                    "skills": [
                        "inflict-damage",
                        "smite",
                        "recruit",
                    ],

                    "name": "Carpals",
                    "faceKey": "skull",
                    "bodyKey": "good",

                    "facts": [
                        "Has a gun.",
                    ]
                },
            }
        },
    }
}
